export default [
    { viewport: [0, 0], slot: [300, 250] },
    { viewport: [768, 0], slot: [704, 90] },
    { viewport: [1024, 0], slot: [960, 250] },
];
